import { Icon } from '@octano/global-ui';
import { useState } from 'react';
import { Tooltip } from 'reactstrap';

interface Props {
  /** Único en la página: se usa como target del Tooltip de reactstrap. */
  id: string;
  text: string;
}

/**
 * Icono de información con tooltip para acompañar el label de un campo de
 * formulario (los inputs de global-ui sólo aceptan `label: string`). Mismo
 * patrón visual que el tooltip de SectionTitle.
 */
export function FieldTooltip({ id, text }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const targetId = `field-tooltip-${id}`;

  return (
    <>
      <span id={targetId} className="ml-1">
        <Icon name="information" color="primary" size="16px" />
      </span>
      <Tooltip
        placement="right"
        isOpen={isOpen}
        target={targetId}
        toggle={() => setIsOpen(!isOpen)}
      >
        {text}
      </Tooltip>
    </>
  );
}
